module.exports = __webpack_public_path__ + "static/media/Group.40e39699.svg";